<template>
    <div>
        <div v-show="exibirParcelamentos">
            <div class="d-flex mb-3">
                <h4>Parcelamentos - {{ investimento.descricao }}</h4>
            </div>
            <app-tabela
                idTabela="tblParcelamentos"
                :itens="investimento.parcelas"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false"
            >
                <template slot="botoes">
                    <div class="d-flex flex-row-reverse mb-3">
                        <b-button class="ml-3" variant="danger" @click="$emit('voltarParaInvestimentos')">
                            <span>
                                <i class="fa fa-history mr-2"></i> Retornar para os Investimentos
                            </span>
                        </b-button>
                        <btn-inserir
                            :investimento="investimento"
                            @obterParcelamentosAtualizados="obterParcelamentos()"
                        ></btn-inserir>
                    </div>
                </template>
                <template slot="valorInvestido" slot-scope="data">
                    {{ data.valorInvestido | currency }}
                </template>
                <template slot="valorTotal" slot-scope="data">
                    {{ data.valorTotal | currency }}
                </template>
                <template slot="status" slot-scope="data">
                    <app-status
                        :status="data.status == 0 ? 'PENDENTE' : 'CONCLUÍDO'"
                    ></app-status>
                </template>
                <template slot="acoes" slot-scope="data">
                    <span class="text-primary float-left mr-1">
                        <i
                            class="fa fa-paperclip fa-lg icon-button"
                            title="Detalhar Anexos"
                            @click.stop="definirTela('anexos', data)"
                        ></i>
                    </span>
                    <btn-atualizar
                        :parcelamento="data"
                        :investimento="investimento"
                        @obterParcelamentosAtualizados="obterParcelamentos()"
                    ></btn-atualizar>
                    <btn-excluir
                        :parcelamento="data"
                        :investimento="investimento"
                        @obterParcelamentosAtualizados="obterParcelamentos()"
                    ></btn-excluir>
                </template>
            </app-tabela>
        </div>
        <div v-show="exibirAnexos">
            <anexo-parcelamento
                :parcelamento="itemSelecionado ? itemSelecionado : {}"
                @voltarParaParcelamentos="definirTela('parcelamentos')"
                @obterParcelamentosAtualizados="obterParcelamentos()"
            >
            </anexo-parcelamento>
        </div>
    </div>
</template>

<script>
import InvestimentoServicos from '../InvestimentoServicos'
import ParcelamentoServicos from './ParcelamentoServicos'
import BtnInserir from './BtnInserirParcelamento'
import BtnAtualizar from './BtnAtualizarParcelamento'
import BtnExcluir from './BtnExcluirParcelamento'
import AnexoParcelamento from './anexoParcelamento/AnexoParcelamento'

export default {
    components: {
        BtnInserir,
        BtnExcluir,
        BtnAtualizar,
        AnexoParcelamento
    },
    props: {
        investimento: {
            type: Object,
            default: () => {}
        },
        contrato: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            campos: [
                {
                    key: 'descricao',
                    label: 'Descrição',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'prazoFinal',
                    label: 'Prazo Final',
                    type: 'date',
                    sortable: true
                },
                {
                    key: 'valorTotal',
                    label: 'Valor Total',
                    sortable: true
                },
                {
                    key: 'valorInvestido',
                    label: 'Valor Investido',
                    sortable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true
                },
                {
                    key: 'observacao',
                    label: 'Observação',
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5,
            telaAtiva: 'parcelamentos',
            itemSelecionado: {}
        }
    },
    methods: {
        obterInvestimentos() {
            this.$store.dispatch('addRequest')
            InvestimentoServicos.obterInvestimentos(
                this.$route.params.contratoId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$emit('atualizarInvestimentos', response.data)
                    } else {
                        this.$toast.error(
                            'Erro ao obter os investimentos',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterParcelamentos() {
            let parcelamentoDto = {
                idContrato: this.investimento.idContrato,
                idInvestimento: this.investimento.idInvestimentoPrevistoContrato
            }
            this.$store.dispatch('addRequest')
            ParcelamentoServicos.obterParcelamentos(parcelamentoDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.investimento.parcelas = response.data
                        } else {
                            this.$toast.error(
                                'Erro ao obter os parcelamentos',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        definirTela(novaTela, data = null) {
            this.telaAtiva = novaTela
            if (data) {
                this.itemSelecionado = data
            }

            if (novaTela == 'parcelamentos') {
                this.obterParcelamentos()
            }
        }
    },

    created() {},

    computed: {
        exibirParcelamentos() {
            return this.telaAtiva === 'parcelamentos'
        },
        exibirAnexos() {
            return this.telaAtiva === 'anexos'
        }
    },

    watch: {}
}
</script>
